import { useState, useEffect, useRef } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { HoverButton } from "./HoverButton";
import { motion, AnimatePresence } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";
import { LanguageDropdown } from "./LanguageDropdown";

export const NavBar = () => {

    const { t } = useLanguage();

    const [scrolled, setScrolled] = useState(false);
    const [activeLink, setActiveLink] = useState("home");
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    // cerrar menú al hacer click fuera
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const onUpdateActiveLink = (value) => {
        setActiveLink(value);
        setMenuOpen(false);
    };

    return (
        <>
            <Navbar className={scrolled ? "scrolled" : ""} fixed="top">
                <Container className="d-flex justify-content-between align-items-center">

                    <span className="nav-logo-text">FranDev</span>

                    <Nav className="ms-auto nav-desktop">
                        <LanguageDropdown />
                        <HoverButton href="#home" text={t.navbar.home} isActive={activeLink === "home"} onClic={() => onUpdateActiveLink("home")} />
                        <HoverButton href="#skills" text={t.navbar.skills} isActive={activeLink === "skills"} onClic={() => onUpdateActiveLink("skills")} />
                        <HoverButton href="#projects" text={t.navbar.projects} isActive={activeLink === "projects"} onClic={() => onUpdateActiveLink("projects")} />
                        <HoverButton href="#contactme" text={t.navbar.contact} isActive={activeLink === "contactme"} onClic={() => onUpdateActiveLink("contactme")} />
                    </Nav>

                    {/* Botón hamburguesa */}
                    <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
                    ☰
                    </button>

                </Container>
            </Navbar>

            {/* Dropdown pequeño (solo móvil) */}
            <AnimatePresence>
                {menuOpen && (
                    <motion.div
                        ref={menuRef}
                        className="dropdown-menu-mobile"
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        transition={{ duration: 0.2 }}
                    >
                        <LanguageDropdown />    
                        <HoverButton href="#home" text={t.navbar.home} isActive={activeLink === "home"} onClic={() => onUpdateActiveLink("home")} />
                        <HoverButton href="#skills" text={t.navbar.skills} isActive={activeLink === "skills"} onClic={() => onUpdateActiveLink("skills")} />
                        <HoverButton href="#projects" text={t.navbar.projects} isActive={activeLink === "projects"} onClic={() => onUpdateActiveLink("projects")} />
                        <HoverButton href="#contactme" text={t.navbar.contact} isActive={activeLink === "contactme"} onClic={() => onUpdateActiveLink("contactme")} />
                    </motion.div>
                    )
                }
            </AnimatePresence>
        </>
    );
};
